import { Tab, TabList } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledRecords = styled.div`
  display: grid;
  justify-content: flex-start;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 3.5rem;
  margin-bottom: 2rem;
`;

export const StyledHeading = styled.span`
  margin: 0;
  font-size: 24px;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;

export const StyledImage = styled.div`
  margin-right: 1rem;
  margin-top: 0rem;
  display: inline-block;
  vertical-align: middle;
`;

export const StyledFilters = styled.div`
  display: grid;
  grid-template-columns: 30% 1fr;
  column-gap: 0.5rem;
  align-items: center;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    row-gap: 5px;
    text-align: left;
  }
`;

export const StyledSearch = styled.div`
  flex: 1;
  text-align: left;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 23rem;
  }
`;

export const StyledTableActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 1rem;
  }
`;

export const StyledSize = styled.span`
  margin-right: 1rem;
  margin-left: 1rem;
  font-size: large;
`;

export const StyledSelect = styled.div`
  display: inline-block;
  vertical-align: middle;
  max-width: 8rem;
  width: 100%;
  text-align: left;
`;

export const StyledNoRecordMessage = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey[900]};
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  margin: 0rem 1rem 7.2rem 1rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
  }
`;

export const StyledText = styled.div`
  display: grid;
  justify-content: flex-start;
  margin-bottom: 4rem;
  width: 100%;
  text-align: left;
  color: ${({ theme }) => theme.colors.paragraph};

  span {
    color: ${({ theme }) => theme.colors.info.main};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    justify-content: center;
  }
`;

export const StyledPagination = styled.div`
  display: grid;
  justify-content: flex-end;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    grid-row: 2;
  }

  @media (max-width: 1320px) {
    justify-content: center;
  }
`;

export const StyledTab = styled(Tab)`
  font-size: 1.8rem;
  margin: 1rem 0rem;
`;

export const StyledTabHeading = styled.span`
  font-size: 2rem;
  padding: 0.6rem;
`;

export const StyledLoadingSpinner = styled.div`
  margin: 25rem 35rem 35rem 65rem;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: black;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const StyledTabHead = styled.div`
  flex: 50;
`;

export const StyledTableActionButton = styled.div`
  margin-right: 1rem;
`;

export const StyledDateTimePicker = styled.div`
  .HXexl {
    gap: 0.2rem;
  }
  .react-datepicker-wrapper .react-datepicker__input-container {
    .jEqwxa {
      padding: 0rem;
      padding-left: 1.5rem;
    }
    .cyoBmk {
      margin: -1rem;
      border: none;
      background-color: transparent;
    }
  }
`;

export const StyledTabList = styled(TabList)`
  margin: 3rem 1.5rem;
`;
